import {observer} from "mobx-react-lite";
import {NavLink, useLocation} from "react-router-dom"
import {noticeController} from "../utils/NoticeController";
import App, {appPages} from "../App"

function WorkupError(props: any) {
    const location = useLocation()
    const error = props.error
    const index = props.key
    const filter = [
        appPages.generalOfferAttributes,
        appPages.offerAttributes
    ]

    let show = true
    filter.map((url)=>{
        if(error.fixPath && error.fixPath.indexOf(url) > -1) {
            show = location.pathname === appPages.offersExport
        }
    })

    if (!show) return null

    return (
        <span className={"alert danger"}>
                <div className={"flexbox space-16 full-width middle"}>
                    <div className={"wide"}>
                        {error.message}
                    </div>
                    {error.fixPath && <div>
                        <NavLink
                            activeClassName={"disabled"}
                            to={error.fixPath}
                            exact
                            className={"button small red"}>Перейти</NavLink>
                    </div>}
                    <div>
                        <span
                            className={"alert-close"}
                            onClick={() => {
                                noticeController.deleteErrorByIndex(index)
                            }}
                        ><i className={"fas fa-times"}/></span>
                    </div>
                </div>

            </span>
    )

}

export const Notices = observer(() => {

    return <div className={"alert-fixed-box large"}>
        {noticeController.errors.map((error, index) =>
            <WorkupError key={index} error={error}/>
        )}

        {noticeController.success.map((success, index) =>
            <span className={"alert success"} key={index}>{success}</span>
        )}
    </div>
})